<template>
  <div class="col-md-8 cda-doc">
    <!-- An outside organization's narrative, rendered as markup. The API has
         sanitised it (NarrativeSanitizer); the sandbox is the second line: no
         script runs in this frame. `allow-same-origin` stays, because the side
         bar finds and highlights rows inside it (CdaVisitableItem, CdaMeasure). -->
    <iframe class="iframe" :id="'cda-'+id" sandbox="allow-same-origin" @load.stop='onCdaLoad' ref='frame'></iframe>
  </div>
</template>
<script>
  import * as srcDoc from 'srcdoc-polyfill';

  export default {
    name: 'cda-doc',
    props: {
      cdaDoc: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: ''
      }
    },
    methods: {
      onCdaLoad() {
        if (!this.$refs.frame) {
          return;
        }
        let srcdocAttribute = this.$refs.frame.getAttribute('srcdoc');
        if(srcdocAttribute) {
          this.$emit('on-cda-load');
        }
        else {
        }
      }
    },
    watch: {
      cdaDoc: function(newCdaDoc) {
        // This component's own frame, the sandboxed one. The first `.iframe`
        // in the document is whichever frame came first - PdfDoc, ReportDoc
        // and the extraction preview use the class on unsandboxed frames -
        // and the C-CDA's markup must never land in one of those.
        if (newCdaDoc && typeof(newCdaDoc) != 'undefined' && this.$refs.frame) {
          srcDoc.set(this.$refs.frame, newCdaDoc);
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .iframe {
    width: 100%;
    height: 90vh;
    background-color: #fff;
    border: 1px solid lighten(#000, 70%);
  }
</style>

